import * as localStorage from "./local-storage";

export { localStorage };
